import React from "react";
import Spinner from "react-bootstrap/Spinner";

/**
 * GlobalLoader component for displaying a global loading spinner.
 * @param {Object} props - Component props.
 * @param {string} [props.extraClasses=""] - Additional CSS classes for customization.
 * @returns {JSX.Element} - Rendered GlobalLoader component.
 */
function GlobalLoader({ extraClasses }) {
  return (
    <div className="text-center">
      <Spinner animation="border" className={`text-500 ${extraClasses}`} />
    </div>
  );
}
export default GlobalLoader;
